<template>
    <div class="m-2">
        <div ref="dropdown" class="dropdown">
            <button
class="form-control dropdown-toggle d-flex justify-content-between align-items-center text-start"
                type="button" :class="{ show: isDropdownOpen }" @click="toggleDropdown">
                <span class="truncated-text">{{ selectedItemName || 'Seleccionar' }}</span>
            </button>
            <ul
class="dropdown-menu custom-dropdown-menu" :class="{ show: isDropdownOpen }"
                :style="{ width: `${dropdownWidth}px` }">
                <li
v-for="item in menuItems" :key="item.id" :class="{ 'selected-item': selectedItemId === item.id }"
                    class="d-flex justify-content-between align-items-center p-1 menu-item" @click="selectItem(item)">
                    <span class="flex-grow-1 ms-3 text-start">{{ item.name }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, watch, nextTick } from 'vue'
import api from '@/services/api'

const props = defineProps({
    label: { type: String, required: true },
    apiurl: { type: String, required: true },
    modelValue: { type: [String, Number], default: '' }
})
const emit = defineEmits(['update:modelValue'])

const menuItems = ref([])
const selectedItemId = ref('')
const selectedItemName = ref('')
const isDropdownOpen = ref(false)
const dropdown = ref(null)
const dropdownWidth = ref('300px')

const isAuthenticated = () => {
    return !!localStorage.getItem('access_token') && !!localStorage.getItem('user')
}

const fetchMenuValues = async () => {
    if (!isAuthenticated()) return
    try {
        const response = await api.get(`/${props.apiurl}`)
        const data = response.data.data || response.data
        menuItems.value = data
        // Seleccionar el valor guardado en localStorage o el primero
        let storedId = localStorage.getItem('center_id')
        if (storedId && data.find(i => i.id == storedId)) {
            selectItem(data.find(i => i.id == storedId))
        } else if (data.length > 0) {
            selectItem(data[0])
        }
    } catch (error) {
        console.error('Error fetching menu values:', error)
    }
}

const selectItem = (item) => {
    selectedItemId.value = item.id
    selectedItemName.value = item.name
    emit('update:modelValue', item.id)
    localStorage.setItem('center_id', item.id)
    isDropdownOpen.value = false
}

const toggleDropdown = async () => {
    dropdownWidth.value = `${dropdown.value.offsetWidth}px`
    if (!isDropdownOpen.value) {
        await fetchMenuValues()
    }
    isDropdownOpen.value = !isDropdownOpen.value
    await nextTick()
}

onMounted(() => {
    if (isAuthenticated()) {
        fetchMenuValues()
    }
})

watch(() => props.modelValue, (newVal) => {
    if (newVal && menuItems.value.length) {
        const found = menuItems.value.find(i => i.id == newVal)
        if (found) selectItem(found)
    }
})
</script>

<style scoped>
.menu-item {
    padding: 6px 12px !important;
    font-size: 14px;
    line-height: 1.2;
    margin: 0 !important;
}

.menu-item:hover,
.selected-item {
    background-color: #eeeeee;
}

.dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
    padding: 0;
    margin-top: 2px;
}

.custom-dropdown-menu {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
}

.truncated-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>